module.exports = __webpack_public_path__ + "static/media/horse-race.735cd438.webp";